import React from 'react';
import ReactCodeInput from 'react-verification-code-input';
import IconButton from '../../common/IconButton';
import Dialog from '../../../utilities/Dialog';
import axios from 'axios';
import { connect } from 'react-redux';
import { AppState } from '../../../store';
import AxiosConfig from '../../../utilities/AxiosConfig';
import Spinner from 'react-bootstrap/Spinner';

export interface IProps {
    userId: string;
    userName: string;
}

const AccessCodeArea: React.FC<IProps> = (props: IProps) => {
    // const submitRef: any = React.createRef();
    const [loading, setLoading] = React.useState(false);
    const [data, setData] = React.useState(null as any);
    const [code, setCode] = React.useState("" as string);
    const [check, setCheck] = React.useState("" as string);
    const [saving, setSaving] = React.useState(false);
    const [showSecondary, setShowSecondary] = React.useState(false);
    const [error, setError] = React.useState("");
    const [refreshKey, setRefreshKey] = React.useState(0);

    const handleCodeCompletion = (value: any) => {
        setCode(value);
        if(value.length === 4){
            setShowSecondary(true);
        }
    }

    const handleCheckCompletion = (value: any) => {
        setCheck(value);
        const element: any = document.getElementById("access-code-submit");
        if(element){
            element.focus();
        }
    }

    const handleSave = async (e: React.SyntheticEvent) => {
        e.preventDefault();
        if(code !== check){
            let alert: any = new Dialog({ 
                type: "alert", 
                message: "Unable to pass verification. Both codes must match.", 
                trueText: "Okay" 
            });
            await alert.show();
            return;
        }
        setSaving(true);
        axios.get(process.env.REACT_APP_API_URL + `/api/user/setaccesscode/${props.userId}/${check}`, AxiosConfig.configValue("min"))
        .then((res: any) => {   
            //console.log(res);
            setData(res.data[0]);
            setError("");
            setShowSecondary(false);
            setRefreshKey(refreshKey + 1);
        })
        .catch((err: any) => {
            //console.log(err, err.response);
            setError("There was a problem saving your access code. Please try again.")
        })
        .finally(() => {setSaving(false);})
    }

    const handleRefresh = (e: React.SyntheticEvent) => {
        e.preventDefault();
        getAccessCode();
    }

    const getAccessCode = () => {
        setLoading(true);
        axios.get(process.env.REACT_APP_API_URL + `/api/user/accesscodes/${props.userId}`, AxiosConfig.configValue("min"))
        .then((res: any) => {
            //console.log(res);
            if(res.data[0]){
                setData(res.data[0]);
                setError("");
            }
        })
        .catch((err: any) => {
            //console.log(err, err.response);
            setError("There was an error getting your access code.")
        })
        .finally(() => {setLoading(false);})
    }

    //r-18-lint-dj
    //eslint-disable-next-line
    React.useEffect(() => { getAccessCode(); }, []);

    return(
        <div>
            <h3 className="d-flex align-items-center flex-row">
                <i className="material-icons text-success h3 m-0">lock</i>
                <span>Access Code for {props.userName}</span>
            </h3>
            {error !== "" && 
                <div className="alert alert-danger">{error}</div>
            }
            <h5 className="d-flex flex-row align-items-center">
                <span>Current Value: </span> 
                <span style={{letterSpacing: 2, marginLeft: 10}}>{loading ? "****" : data?.Code ? data.Code: "Not Set"}</span>
                {loading ? <Spinner size="sm" animation="border" /> : <i onClick={handleRefresh} className="material-icons action-text">autorenew</i>}
            </h5>
            <h5>Create or Change</h5>
            <ReactCodeInput key={refreshKey} disabled={loading} className="permissions-code-input" fields={4} type="number" autoFocus onComplete={handleCodeCompletion} />
            {showSecondary && 
            <div className="d-flex flex-column flex-md-row align-items-center">
                <div className="d-flex flex-column">
                    <span className="font-weight-bold text-secondary">Re-enter to confirm</span>
                    <ReactCodeInput disabled={loading} className="permissions-code-input" fields={4} type="number" onComplete={handleCheckCompletion} />
                </div>
                <IconButton id="access-code-submit" style={{marginLeft: 20}} disabled={saving || loading} showSpinner={saving} onClick={handleSave} icon="save">Save</IconButton>
            </div>
            }
        </div>
    )
}

const mapStateToProps = (state: AppState) => ({ userId: state.user.userId, userName: state.user.userName });

export default connect(mapStateToProps)(AccessCodeArea)